import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/PageLayout.css';
import Footer from '../components/layout/Footer';

const SplashPage = () => {
  return (
    <section className="page-container">
      <div className="feature-card text-center">
        <h1 className="text-3xl font-bold mb-4">Give Your App a Memory.</h1>
        <p className="page-section mb-6">
          Mind Mesch gives your app memory, emotion, and intelligence — with zero backend complexity.
          It's how you future-proof your product, boost engagement, and outpace every competitor still stuck in the past.
        </p>
        <p>
        Especially for AI-driven apps, Mind Mesch gives you the power to feed the LLM with real **intent**, **emotion**, **tone**, **tags**, and **contextual history**. 
        That means your app can respond with emotionally intelligent nuance — matching user mood, mirroring intent, and acting on real context and past memories of user input.
        </p>
        <p className="splash-nav-links mb-6">
          <Link to="/about">Explore</Link>
          {' '}|{' '}
          <Link to="/benefits">Benefits</Link>
          {' '}|{' '}
          <Link to="/partner/plans">Start Free Trial</Link>
        </p>
      </div>

      <div className="feature-card">
        <h2 className="text-xl font-semibold mb-2">🧠 Effortless Memory Recall</h2>
        <ul className="list-disc list-inside">
          <li>Journal-style memory capture</li>
          <li>Tracks what was said, how it felt, and when it mattered</li>
          <li>No backend setup needed — we handle the hard part</li>
        </ul>
        <p className="page-subtle-note mt-2">
          🔐 <strong>Worried about storage?</strong> Our system is encrypted end-to-end and privacy-forward. <Link to="/faq">Learn how it works.</Link>
        </p>
      </div>

      <div className="feature-card">
        <h2 className="text-xl font-semibold mb-2">💬 Emotion + Intent Intelligence</h2>
        <ul className="list-disc list-inside">
          <li>Detects tone, emotion, and user intent</li>
          <li>Auto-tags goals, gratitude, reminders, and more</li>
          <li>Lets your AI respond with emotional nuance</li>
        </ul>
        <p className="page-subtle-note mt-2">
          🤖 <strong>Compatible with your stack.</strong> Integrates seamlessly with OpenAI, Claude, and more.
        </p>
      </div>

      <div className="feature-card">
        <h2 className="text-xl font-semibold mb-2">🔐 Obfuscated Identity = Zero Regret</h2>
        <ul className="list-disc list-inside">
          <li>Deterministic shadow IDs — never store real user data</li>
          <li>GDPR-aligned, SOC 2-ready design</li>
          <li>Earn user trust by never compromising privacy</li>
        </ul>
        <p className="page-subtle-note mt-2">
          🔍 <strong>Data never tied to identity.</strong> Your users stay safe. Your app stays trusted.
        </p>
      </div>

      <div className="feature-card text-center mt-8">
        <h2 className="text-xl font-bold mb-2">🚀 Want to see it live?</h2>
        <p>
          Try <a href="https://daisypal.com/chat" className="cta-link" target="_blank" rel="noreferrer">dAIsy</a> — our AI demo powered by the same memory engine you'll integrate.
        </p>
      </div>

      <p className="text-xs text-gray-500 mt-8 text-center">
        Built with ❤️ for developers who give a damn about their users. Be one of them.
      </p>
      <Footer />
    </section>
  );
};

export default SplashPage;
